// extracted by mini-css-extract-plugin
module.exports = {"link":"link_link__fHWk6","tertiary-light":"link_tertiary-light__TEpwU","tertiary-dark":"link_tertiary-dark__9TAAn"};